// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"350":"48706269","982":"ffc407b4"}[chunkId] + ".css";
};